import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { EditOrderEffects } from './+state/edit-order/edit-order.effects';
import { editOrderFeature } from './+state/edit-order/edit-order.reducers';
import { OrderEffects } from './+state/order/order.effects';
import { orderFeature } from './+state/order/order.reducers';

export const provideOrderDomain = () => {
  return makeEnvironmentProviders([
    provideState(orderFeature),
    provideState(editOrderFeature),
    provideEffects([OrderEffects, EditOrderEffects]),
  ]);
};
